import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ErrorMessagesServiceBase } from '../form-helper';

@Injectable()
export class ErrorMessagesService implements ErrorMessagesServiceBase {
  getErrorMessage(errors: ValidationErrors, fieldName: string, customMessage?: string | undefined): string | null | unknown {
    let params = null;

    if (errors['minlength']) {
      params = errors['minlength']?.requiredLength;
    }

    if (errors['maxlength']) {
      params = errors['maxlength']?.requiredLength;
    }

    return errors ? { text: fieldName + '.' + Object.keys(errors)[0], params } : null;
  }
}
